module.exports = __webpack_public_path__ + "img/strikethrough.190c6987.svg";